import { Component, OnInit } from '@angular/core';
import { RoutesRecognized } from '@angular/router';
import { htmlAstToRender3Ast } from '@angular/compiler/src/render3/r3_template_transform';

@Component({
  selector: 'app-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss']
})
export class TabsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    // this.test();
    this.selectTab();
  }
  ngOnChanges(){
    
  }
  activeTab = 'search';
  routes = [
    {
      name: 'Allocation',
      link: 'current-allocation',
      number: '1',
      status: 'active'
    },
    {
      name: 'Enhanced',
      link: 'enhanced-allocation',
      number: '2',
      status: 'active'
    },
    {
      name: 'Comparison',
      link: 'allocation-comparison',
      number: '3',
      status: 'active'
    }
  ]
  search(activeTab){
      this.activeTab = activeTab;
  }
  setActiveTab(routeNumber){
    for (let i = 0; i < this.routes.length; i++){
      // if (i+1 != routeNumber){
      //   this.routes[i].status = '';
      //   document.getElementById('tab-'+String(routeNumber)).className = '';
      // }
      // else{
      //   this.routes[i].status = 'active';
      //   console.log(routeNumber);
      //   document.getElementById('tab-'+String(routeNumber)).className = 'active';
      // }
      // console.log(routeNumber);
      if (i+1 == Number(routeNumber)){
        // this.routes[i].status = 'active';
        console.log(routeNumber);
        document.getElementById('tab-'+String(routeNumber)).className = 'active';
      }
      else{
        // this.routes[i].status = 'active';
        document.getElementById('tab-'+String(routeNumber)).className = '';
      }
      
    }
  }
  setActive(id){
    document.getElementById('tab-'+String(id)).className = 'active';
    // for (let i = 1; i <= this.routes.length; i++){
    //   if (i!=Number(id)){
    //     document.getElementById('tab-'+String(id)).className = '';
    //     console.log('I: '+ i);
    //     console.log('ID: ' + id);
    //   }
    // }
  }

  result(activeTab){
      this.activeTab = activeTab;
  }

  // btnContainer: any;
  // btns: any;
  // test(){
  //   // Get the container element
  //   this.btnContainer = document.getElementById("myDIV");
  //   console.log('Inner HTML: ' + this.btnContainer.innerHTML);
  //   // Get all buttons with class="btn" inside the container
  //   this.btns = this.btnContainer.getElementsByClassName("btn");
  //   console.log('Number of Buttons: ' + this.btns.length);
  //   // Loop through the buttons and add the active class to the current/clicked button
  //   for (let i = 0; i < this.btns.length; i++) {
  //     this.btns[i].addEventListener("click", function() {
  //       var current = document.getElementsByClassName("active");

  //       // If there's no active class
  //       if (current.length > 0) {
  //         current[0].className = current[0].className.replace(" active", "");
  //       }

  //       // Add the active class to the current/clicked button
  //       this.className += " active";
  //     });
  //   } 
  // }
  tabs: any;
  tabContainer: any;
  selectTab(){
    this.tabContainer = document.getElementById("tab-list");
    // let tabsli = tabContainer.getElementsByClassName('li-tab');
    console.log('Inner HTML: ' + this.tabContainer.innerHTML);
    this.tabs = this.tabContainer.getElementsByClassName("special-tab");
    console.log('Number of Tabs: ' + this.tabs.length);
    for (let i = 0; i < this.tabs.length; i++) {
      this.tabs[i].addEventListener("click", function() {
        var current = document.getElementsByClassName("active");
        // console.log(current.);

        // If there's no active class
        if (current.length > 0) {
          current[0].className = current[0].className.replace(" active", "");
        }

        // Add the active class to the current/clicked button
        this.className += " active";
      });
    }

  }
  

}
